export const CLICK_AND_COLLECT = "187";
export const FREE_CLICK_AND_COLLECT_THRESHOLD = 40;

export enum DeliveryMessage {
  FreeStandardDelivery = "Free standard delivery",
  FreeStandardDeliveryOverThreshold = "Free standard delivery over {price}",
  FreeUKMainlandDelivery = "Free UK mainland delivery",
  FreeUKMainlandDeliveryOverThreshold = "Free UK mainland delivery over £50",
  None = "",
}
